"use client";

import { useReportWebVitals } from "next/web-vitals";
import {
  isSampledWebVitalsSession,
  isSyntheticUserAgent,
  webVitalsSampleRate,
} from "@/lib/web-vitals-sampling";

const SAMPLE_STORAGE_KEY = "hf_web_vitals_sampled";

function isSampledSession(): boolean {
  return isSampledWebVitalsSession({
    storage: window.sessionStorage,
    storageKey: SAMPLE_STORAGE_KEY,
    rate: webVitalsSampleRate(process.env.NEXT_PUBLIC_WEB_VITALS_SAMPLE_RATE),
  });
}

function shouldReport(): boolean {
  if (isSyntheticUserAgent(window.navigator.userAgent)) return false;
  return isSampledSession();
}

/**
 * Gerçek kullanıcı Web Vitals ölçümlerini GA4'e gtag olayı olarak yollar (LCP, INP, CLS…).
 * Örnekleme oturum boyunca sabittir; sentetik denetim ve bot trafiği dışlanır.
 */
export default function WebVitals() {
  useReportWebVitals((metric) => {
    if (!shouldReport()) return;

    // GA4'e dogrudan gtag olayi (2026-09-30). Eskiden dataLayer'a ham `{event:"web_vitals"}`
    // itiliyordu; GTM kapsayicisi bos oldugu icin olcum HICBIR YERE gitmiyordu. gtag() konsent
    // betiginde tanimli: analytics yuklenmeden once de kuyruga yazar, izin verilmemisse GA4
    // cerezsiz (consent mode) isler.
    const w = window as Window & { gtag?: (...args: unknown[]) => void; dataLayer?: unknown[] };
    // gtag.js yalniz `arguments` nesnesini komut sayar; dizi itmek sessizce yok sayilir.
    const gtag = w.gtag ?? function gtagFallback() { (w.dataLayer = w.dataLayer ?? []).push(arguments); };
    gtag("event", metric.name, {
      value: Math.round(metric.name === "CLS" ? metric.delta * 1000 : metric.delta),
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      navigation_type: metric.navigationType,
      page_path: window.location.pathname,
      non_interaction: true,
    });
  });

  return null;
}
